import { useEffect, useState } from "react";


import { toast } from "sonner";

import { Button } from "../../../components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../../components/ui/dialog";
import { getCharCount } from "../../../lib/utils.js";
import { useApi } from "../../../context/ApiContext";

import ContractorForm from "./ContractorForm";

const ContractorDialog = ({ isOpen, onOpenChange, onSuccess, editingContractor = null }) => {
  const api = useApi();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    contractorName: "",
    contact: "",
    type: "",
    referBy: "",
    address: ""
  });
  const isAddressOverLimit = getCharCount(formData.address) > 500;

  useEffect(() => {
    if (editingContractor) {
      setFormData({
        contractorName: editingContractor.contractorName || "",
        contact: editingContractor.contact || "",
        type: editingContractor.type || "",
        referBy: editingContractor.referBy || "",
        address: editingContractor.address || ""
      });
    } else {
      setFormData({
        contractorName: "",
        contact: "",
        type: "",
        referBy: "",
        address: ""
      });
    }
  }, [editingContractor, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isAddressOverLimit) {
      toast.error("Address exceeds the 500-character limit.");
      return;
    }
    setLoading(true);
    try {
      let response;
      if (editingContractor) {
        response = await api.put(`/contractors/${editingContractor.id}`, formData);
        toast.success("Contractor updated successfully!");
      } else {
        response = await api.post(`/contractors`, formData);
        toast.success("Contractor created successfully!");
      }

      if (onSuccess) onSuccess(response.data);
      onOpenChange(false);
    } catch (error) {
      toast.error(error.message || "Error saving contractor");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] p-0 overflow-hidden flex flex-col">
        <div className="p-6 pb-0">
          <DialogHeader>
            <DialogTitle>{editingContractor ? "Edit Contractor" : "Create New Contractor"}</DialogTitle>
            <DialogDescription>
              {editingContractor ? "Update contractor information" : "Add a new contractor to the system"}
            </DialogDescription>
          </DialogHeader>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col flex-1 overflow-hidden">
          <div className="flex-1 overflow-y-auto p-6 space-y-4">
            <ContractorForm formData={formData} setFormData={setFormData} />
          </div>
          <div className="p-6 pt-2 border-t bg-white dark:bg-yale-blue-900 sticky bottom-0 z-10">
            <Button type="submit" variant="primary" className="w-full py-6 rounded-lg shadow-lg" disabled={loading || isAddressOverLimit}>
              {loading ? "Saving..." : editingContractor ? "Update Contractor" : "Create Contractor"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ContractorDialog;
